import React, { ReactElement } from 'react';
import ChartFunnel from '../../../components/chart-funnel/chart-funnel.component';
import Widget from '../../../components/widget/widget.component';
import CurrencyService from '../../../services/currency-service';
import { WIDGET_NAME_DEAL_PIPELINE_FUNNEL } from '../../../constants/system/widget-names';
import CURRENCY_USD from '../../../constants/system/currencies';

const DashboardWidgetDealPipelineFunnel: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_CONTAINER_CHART_DEAL_PIPELINE_FUNNEL: string = 'container-chart-deal-pipeline-funnel';
  const WIDGET_TITLE_DEFAULT: string = 'Deal Pipeline Funnel';

  const {
    widgetSettings,
    dealStatusGroupListData,
    onWidgetSettingsChange,
  } = props;

  const totalValue: number = dealStatusGroupListData && dealStatusGroupListData.length
    ? dealStatusGroupListData.reduce((resultTotalValue: number, dealStatusGroup: DealStatusGroup): number => (
      resultTotalValue + dealStatusGroup.value
    ), 0) : 0;
  const chartItemList: ChartFunnelItem[] = dealStatusGroupListData && dealStatusGroupListData.length
    ? dealStatusGroupListData.map((dealStatusGroupItem: DealStatusGroup): ChartFunnelItem => ({
      name: dealStatusGroupItem.name,
      value: dealStatusGroupItem.value,
    })) : [];

  return (
    <Widget
      withCustomizeMode
      isEmpty={!dealStatusGroupListData || !dealStatusGroupListData.length || !totalValue || totalValue <= 0}
      widgetName={WIDGET_NAME_DEAL_PIPELINE_FUNNEL}
      defaultWidgetTitle={WIDGET_TITLE_DEFAULT}
      widgetSettings={widgetSettings}
      onWidgetSettingsChange={onWidgetSettingsChange}
    >
      <ChartFunnel
        containerId={ID_CONTAINER_CHART_DEAL_PIPELINE_FUNNEL}
        currencySign={CurrencyService.getCurrencySign(CURRENCY_USD)}
        chartItemList={chartItemList}
        totalValue={totalValue}
      />
    </Widget>
  );
});

export default DashboardWidgetDealPipelineFunnel;
